import StudioPage from "./Studio";
export default StudioPage;